export enum FilterMode {
  Subtractive = -1,
  Additive = 1
}

export type FilterSelectValue = {
  mode: FilterMode;
  values: string[];
};

export type FilterSelectValueMap = {
  [index: string]: FilterSelectValue;
};

export type FilterSelectOption = {
  value: string;
  count: number;
  label?: string;
};
